import { createFileRoute, Link } from "@tanstack/react-router";
import { AdminCoachingTab } from "@/components/admin/AdminCoachingTab";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/admin/coaching")({
  head: () => ({ meta: [{ title: "Practice Hub | Admin" }] }),
  component: AdminCoachingPage,
});

function AdminCoachingPage() {
  return (
    <>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-foreground/60">
          Practice Hub library is live for members. Ask Mark submissions are hidden for now.
        </p>
        <Button asChild variant="outline" size="sm" className="border-white/20">
          <Link to="/practice">Preview member view</Link>
        </Button>
      </div>
      <AdminCoachingTab />
    </>
  );
}
